import React, { useState, useEffect, useRef } from 'react';
import { Document, Page, pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

import { SquaredButton } from '../builder/ActionButton';
import ButtonCollection from '../builder/ButtonCollection';
import Loader from '../builder/Loader';
import { addHttpsIfMissing } from '../../lib/ep';

const ARROW_U = 38;
const ARROW_D = 40;
let throttleChange = null;

const PdfEmbed = (props) => {
	const num_pages = useRef(null);
	const page_number = useRef(1);
	const [page, setPage] = useState(page_number.current);
	const [zoomed, setZoomed] = useState(false);
	const [loading, setLoading] = useState(true)

	const device = (props.device != undefined) ? props.device : 'desktop';
	const file = props?.full_file ?? addHttpsIfMissing(`${props.file.full_path}originals/${props.file.name}`);
	const skip_actions = props?.skip_actions ?? false;


	const container_id = 'ResumeContainer';

	const [container_w, setContainerW] = useState(null);
	const [container_h, setContainerH] = useState(null);

	const container_item = useRef(null);

	useEffect(() => {
		container_item.current = document.getElementById(container_id);

		document.addEventListener('keydown', handleKeyDown);
		window.addEventListener('resize', resize_screen);

		return () => {
			document.removeEventListener('keydown', handleKeyDown);
			window.removeEventListener('resize', resize_screen);
		}
	}, []);

	const resize_screen = (e) => {
		if(throttleChange != undefined) clearInterval(throttleChange);

		throttleChange = setTimeout(() => {
			setContainerW(container_item.current.offsetWidth);
			setContainerH(container_item.current.offsetHeight);
		}, 300);
	};

	const handleKeyDown = (e) => {
		switch(e.keyCode) {
			case ARROW_U:
				goPreviousPage();
				e.preventDefault();
				break;

			case ARROW_D:
				goNextPage();
				e.preventDefault();
				break;
		}
	};

	const onDocumentLoadSuccess = (pdf) => {
		num_pages.current = pdf.numPages;
		resize_screen();
		setTimeout(() => {
			setLoading(false);
		}, 100);
	};

	const error = (error) => {
	};

	const goPreviousPage = () => {
		changePage(-1);
	};

	const goNextPage = () => {
		changePage(1)
	};

	const changePage = (offset) => {
		page_number.current = Math.min(num_pages.current, Math.max(1, (page_number.current + offset)));
		setPage(page_number.current);
	};

	const toggleZoom = () => {
		container_item.current.scrollTop = 0;
		setZoomed(!zoomed);
	};

	return (
		<div id={container_id} class={'pdf_container' + ((zoomed) ? ' is_zoomed_in' : '')} >
			{(!skip_actions) && (
				<nav class="pdf_navigation">
					<ButtonCollection>
						{(device == 'desktop') && (
							<SquaredButton
								color={false}
								icon={(!zoomed) ? 'knk-magnify-in' : 'knk-magnify-out'}
								_class={{ other:'original_color_item' }}
								onClick={() => toggleZoom()}
								aria-label="Zoom"
							/>
						)}

						{(loading) && (
							<div class="loading_pdf" style={{minWidth:'60px'}}>
								<Loader />
							</div>
						)}

						{(!loading && page && num_pages.current) && (
							<SquaredButton
								color={false}
								icon='knk-arrow-l-big'
								_class={{ other:'original_color_item' }}
								disabled={page <= 1}
								onClick={() => goPreviousPage()}
								aria-label="Go to previous page"
							/>
						)}

						{(!loading && page && num_pages.current) && (
							<SquaredButton
								color={false}
								icon='knk-arrow-r-big'
								_class={{ other:'original_color_item' }}
								disabled={(page + 1) > num_pages.current}
								onClick={() => goNextPage()}
								aria-label="Go to next page"
							/>
						)}

						<SquaredButton
							color={false}
							icon='knk-download'
							_class={{ other:'original_color_item' }}
							_href={file}
							_target="_blank"
							aria-label="Download"
						/>
					</ButtonCollection>
				</nav>
			)}

			<Document className={'PDFDocument' + ((loading) ? ' loading' : '')} file={file} onLoadSuccess={onDocumentLoadSuccess} onLoadError={error}>
				<Page
					className="PDFPage"
					pageNumber={page}
					renderTextLayer={false}
					renderInteractiveForms={false}
					width={(zoomed) ? container_w : null}
					height={(!zoomed) ? container_h : null}
				/>
			</Document>
		</div>
	)
};

export default PdfEmbed;